export enum AsicStatus {
  NotLodged,
  Pending,
  WaitingForASIC,
  Validated,
  ManualProcessing,
  Lodged,
  MarkedAsLodged,
  FutureLodgement,
  Rejected
}
